import {
    UnbHeightPx,
    NavHeightPxDesktop,
    NavHeightPxMobile,
} from 'constants/navBar';
import styled from 'styled-components';
import { Box } from '@landr/maestro';

const AppContentWrapper = styled(Box)`
    position: relative;
    min-height: calc(100vh - (${UnbHeightPx}px + ${NavHeightPxDesktop}px));

    ${({ theme }): string => theme.breakpoint('md')`
        min-height: calc(100vh - (${UnbHeightPx}px + ${NavHeightPxMobile}px));
    `}
`;

export default AppContentWrapper;
